import { AxiosUtilsType, axiosGet } from './axiosUtils';
import './axiosInterceptor';

const MenuService = {
  async getMenu(): AxiosUtilsType {
    return await axiosGet(`menu/dashboard`);
  },
};
export default MenuService;
